// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1p4S5","large":"styles_large__30DeA"};